function pluralizeLearningCollectionType(type) {
  switch (type) {
    case "MODULE":
      return "modules";
    case "PROJECT":
      return "projects";
    case "SUPERBADGE":
      return "superbadges";
    case "TRAIL":
    case "LEARNINGPATH":
      return "trails";
    case "TRAILMIX":
      return "trailmixes";
    default:
      return type;
  }
}

export { pluralizeLearningCollectionType };
